// Vanilla JavaScript implementation of address field functionality
document.addEventListener("DOMContentLoaded", () => {
  const addressFields = document.querySelectorAll(".basic-form__address");

  addressFields.forEach(field => {
    const select = field.querySelector(".select-input");
    const input = field.querySelector(".address-input");

    // Initialize state
    if (select && input) {
      updateInputState(select, input);

      // Add event listener for select changes
      select.addEventListener("change", event => {
        const selectedAddress = event.target.value;

        if (!input) {
          console.error("Address input field not found");
          return;
        }

        if (selectedAddress) {
          input.value = selectedAddress;
          input.setAttribute("value", selectedAddress);
          // input.disabled = true;

          // Trigger change event to ensure any listeners are notified
          const changeEvent = new Event("change", { bubbles: true });
          input.dispatchEvent(changeEvent);
        } else {
          input.value = "";
          input.disabled = false;
        }
      });
    }
  });

  // Helper function to update input state based on select value
  function updateInputState(select, input) {
    if (!input) return;

    try {
      const hasSelectedAddress = select.value !== "";
      input.disabled = hasSelectedAddress;
      input.value = select.value;
      console.log("Address input updated:", input.value);
    } catch (error) {
      console.error("Error updating input state", error);
    }
  }
});
